import ReportList from '../components/report/List.vue';

export default [
  { name: 'ReportList', path: '/report/', component: ReportList },
];



// WEBPACK FOOTER //
// ./src/routes/report.js